import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import "./pie-chart-statistics.scss";
// Đăng ký các thành phần cần thiết của Chart.js
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const salesData = [
  { bank: "Bank A", sales: 5000 },
  { bank: "Bank B", sales: 3000 },
  { bank: "Bank C", sales: 2000 },
  { bank: "Bank D", sales: 1000 },
];
export const PieChartStatistic = () => {
  const labels = salesData.map((data) => data.bank); // Tên ngân hàng
  const data = salesData.map((data) => data.sales); // Doanh số tương ứng

  const chartData = {
    labels, // Nhãn (tên ngân hàng)
    datasets: [
      {
        label: "Sales by Bank (USD)",
        data, // Doanh số
        backgroundColor: [
          "rgba(75, 192, 192, 0.7)", // Bank A
          "rgba(255, 205, 86, 0.7)", // Bank B
          "rgba(255, 99, 132, 0.7)", // Bank C
          "rgba(153, 102, 255, 0.7)", // Bank D
        ],
        borderColor: [
          "rgba(75, 192, 192, 1)",
          "rgba(255, 205, 86, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(153, 102, 255, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const, // Hiển thị chú thích phía trên
      },
      title: {
        display: true,
        text: "Sales by Bank Account", // Tiêu đề biểu đồ
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            const sales = data[tooltipItem.dataIndex];
            const totalSales = data.reduce((acc, curr) => acc + curr, 0);
            const percentage = ((sales / totalSales) * 100).toFixed(2);
            return `${sales} USD (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <div className="pie-statistic-container">
      <div className="pie-statistic-header">
        <div>
          <span className="title">{"Doanh thu theo tài khoản ngân hàng"}</span>
        </div>
      </div>

      <div className="pie-statistic-body">
        <div className="chart-ctn">
          <div className="pieChart">
            <Pie data={chartData} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
};
